import { Component, OnInit, ViewEncapsulation, Output, EventEmitter, ViewChild } from '@angular/core';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import './doc-history.component.css';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { SimplePdfViewerComponent, SimplePDFBookmark } from 'simple-pdf-viewer';

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-doc-history',
  templateUrl: './doc-history.component.html',
  providers: [ApiService],
  encapsulation: ViewEncapsulation.None
})
export class DocHistoryComponent implements OnInit {

  qboDocuments: any = [];
  currentDate: {};
  display: boolean = false;
  fromDate = new Date();
  formattedDate: any;
  userform: FormGroup;
  ScanPdfPath: any;
  loadingMessage: any = "Loading...";

  searchInvoiceNumber: any;
  searchSupplier: any;
  @ViewChild(SimplePdfViewerComponent) private pdfViewer: SimplePdfViewerComponent;
  bookmarks: SimplePDFBookmark[] = [];
  @Output() childEvent = new EventEmitter();

  constructor(private router: Router, private api: ApiService,
    private spinner: NgxSpinnerService, private http: HttpClient, private fb: FormBuilder) { }

  ngOnInit() {

    this.currentDate = new Date();
    this.currentDate = new Date().toISOString().split('T')[0];


    this.fromDate.setMonth(this.fromDate.getMonth() - 1);
    this.formattedDate = this.fromDate.toISOString().slice(0, 10);


    this.userform = this.fb.group({
      'FromDate': new FormControl("", Validators.required),
      'ToDate': new FormControl("", Validators.required),

    });

    this.getHistoryDocument();
  }


  getHistoryDocument() {

    this.spinner.show();
    this.loadingMessage = "Processing...";
    this.api.get('Rah/GetQboDocumentHistoryByDate?fromdate=' +
      this.formattedDate + "&todate=" + this.currentDate, "").subscribe(
        (res: {}) => this.sucessGetDocuments(res),
        error => this.failedGetDocument(<any>error));

  }

  onFromDateChange(event: any) {
    this.formattedDate = event.target.value; // Update formattedDate when the input changes
  }

  onToDateChange(event: any) {
    this.currentDate = event.target.value; // Update formattedDate when the input changes
  }

  dateFilter() {

    console.log("this.formattedDate")
    console.log(this.formattedDate)

    console.log("this.currentDate")
    console.log(this.currentDate)

    this.spinner.show();

    this.api.get('Rah/GetQboDocumentHistoryByDate?fromdate=' +
      this.formattedDate + "&todate=" + this.currentDate, "").subscribe(
        (res: {}) => this.sucessGetDocuments(res),
        error => this.failedGetDocument(<any>error));


  }

  onSearchInvoiceNumber() {
    if (this.searchInvoiceNumber.length > 2) {
      console.log("this.invoiceNumber ");
      console.log(this.searchInvoiceNumber);
      this.spinner.show();

      this.api.get('Rah/GetQboDocumentHistoryByInvoiceNumber?refNumber=' + this.searchInvoiceNumber, "").subscribe(
        (res: {}) => this.sucessGetDocuments(res),
        error => this.failedGetDocument(<any>error));
    }
  }

  onSearchSupplier() {
    if (this.searchSupplier.length > 2) {
      console.log("this.searchSupplier ");
      console.log(this.searchSupplier);
      this.spinner.show();

      this.api.get('Rah/GetQboDocumentHistoryBySupplier?supplier=' + this.searchSupplier, "").subscribe(
        (res: {}) => this.sucessGetDocuments(res),
        error => this.failedGetDocument(<any>error));
    }

  }

  sucessGetDocuments(resp: any) {
    console.log(resp);
    this.qboDocuments = resp.Data;
    this.qboDocuments.forEach(element => {
      if(element.fromEmail==0)
           element.PostedBy='Manual';
      else
          element.PostedBy='Automatic';
    });
    this.spinner.hide();

  }

  failedGetDocument(resp: any) {
    console.log(resp);
    this.spinner.hide();
  }

  onSubmit(value: string) {

    if (this.userform.valid) {

      console.log(this.userform.value)
      this.spinner.show();

      this.api.get('Rah/GetQboDocumentHistoryByDate?fromdate=' +
        this.userform.value.FromDate + "&todate=" + this.userform.value.ToDate, "").subscribe(
          (res: {}) => this.sucessGetDocuments(res),
          error => this.failedGetDocument(<any>error));


    }
  }

  showPdf(value: any) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');

    this.http.get(this.api.apiBaseUrl + 'Scan/GetQbDocumentFile?qboDocumentID=' + value.DocumentID, { headers: headers, responseType: 'blob' }).subscribe(
      (res: {}) => this.sucessDocumentFile(res),
      error => this.failedDocumentFile(<any>error));
  }


  sucessDocumentFile(resp: any) {
    this.display = true;
    this.openDocument1(resp);
  }

  failedDocumentFile(resp: any) {

  }
  openDocument1(document: File) {
    this.ScanPdfPath = document;
    const fileReader: FileReader = new FileReader();
    fileReader.onload = () => {
      this.pdfViewer.openDocument(new Uint8Array(fileReader.result));
    };
    fileReader.readAsArrayBuffer(document);
  }


  downloadPDF(value: any) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');

    this.http.get(this.api.apiBaseUrl + 'Scan/GetQbDocumentFile?qboDocumentID=' + value.DocumentID, { headers: headers, responseType: 'blob' }).subscribe(
      (res: {}) => this.sucessDocumentFilePath(res, value.ScanFile_Name),
      error => this.failedDocumentFile(<any>error));
  }

  sucessDocumentFilePath(resp: any, filename: any) {
    console.log(resp);

    let file = new Blob([resp], { type: 'pdf;charset=utf-8' });
    FileSaver.saveAs(file, filename);
    console.log(resp);
  }

  // exportExcel() {
  //   import("xlsx").then(xlsx => {
  //       const worksheet = xlsx.utils.json_to_sheet(this.qboDocuments); // Sale Data
  //       const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
  //       const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
  //      // this.saveAsExcelFile(excelBuffer, "sales");
  //   });
  // }


//   exportExcel() {
  
//     import('xlsx').then(xlsx => {
//         const worksheet = xlsx.utils.json_to_sheet(this.qboDocuments);
//         const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
//         const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
//        // this.saveAsExcelFile(excelBuffer, "qboDocuments");

//     });
// }


// saveAsExcelFile(buffer: any, fileName: string): void {
//     let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
//     let EXCEL_EXTENSION = '.xlsx';
//     const data: Blob = new Blob([buffer], {
//         type: EXCEL_TYPE
//     });
//     FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
// }

// exportExcel() {
//   console.log('this.appResults.output.data=', this.appResults.output.data)
//   import("xlsx").then(xlsx => {
//     const worksheet = xlsx.utils.json_to_sheet(this.appResults.output.data);
//     const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
//     const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
//     this.saveAsExcelFile(excelBuffer, "Results");
//   });
// }

// saveAsExcelFile(buffer: any, fileName: string): void {
//   import("file-saver").then(FileSaver => {
//     let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
//     let EXCEL_EXTENSION = '.xlsx';
//     const data: Blob = new Blob([buffer], {
//       type: EXCEL_TYPE
//     });
//     FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
//   });
// }

}
